module.exports = __webpack_public_path__ + "static/media/Bundaberg.478e78c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Bundaberg.png
// module id = 605
// module chunks = 0